import type React from 'react';
import { motion } from 'framer-motion';
import { fadeInUp } from '../utils/animations';
import Section from './ui/Section';
import ContactForm from './ui/ContactForm';
import serverRoomImage from '../assets/images/server-room.jpg';

const MainCTA: React.FC = () => {
  return (
    <Section id="main-cta" bgColor="white" noPadding>
      <div className="grid md:grid-cols-2">
        {/* Left side - Image and text overlay */}
        <div
          className="relative h-64 md:h-auto"
          style={{
            backgroundImage: `linear-gradient(rgba(26, 34, 38, 0.75), rgba(26, 34, 38, 0.85)), url(${serverRoomImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        >
          <div className="absolute inset-0 flex flex-col items-center justify-center p-8 md:p-12 text-center text-white">
            <motion.h2
              className="mb-6 text-3xl md:text-4xl font-bold leading-tight"
              variants={fadeInUp}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
            >
              Готовы оптимизировать вашу IT-инфраструктуру?
            </motion.h2>
            <motion.p
              className="text-lg text-white/90 max-w-md"
              variants={fadeInUp}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
            >
              Оставьте заявку прямо сейчас и получите бесплатную консультацию
            </motion.p>
          </div>
        </div>

        {/* Right side - Form */}
        <div className="bg-white p-8 md:p-12">
          <motion.div
            variants={fadeInUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            <h3 className="mb-6 text-2xl font-bold text-primary">
              Запросить консультацию
            </h3>
            <p className="mb-6 text-gray-600">
              
            </p>
            <ContactForm
              withComment
              submitLabel="Получить бесплатную консультацию"
              successMessage="Спасибо за вашу заявку! Наш специалист свяжется с вами в течение 15 минут в рабочее время или в ближайший рабочий день."
            />
          </motion.div>
        </div>
      </div>
    </Section>
  );
};

export default MainCTA;
